(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  function initialize(root = document) {
    root.querySelectorAll('[data-st-carousel]').forEach(carousel => {
      if (carousel.dataset.ready) return;
      carousel.dataset.ready = 'true';
      const slides = [...carousel.querySelectorAll('[data-st-slide]')];
      const dots = [...carousel.querySelectorAll('[data-st-dot]')];
      let active = 0;
      const show = index => {
        active = (index + slides.length) % slides.length;
        slides.forEach((slide, i) => { slide.hidden = i !== active; });
        dots.forEach((dot, i) => {
          dot.classList.toggle('is-active', i === active);
          dot.setAttribute('aria-pressed', String(i === active));
        });
        carousel.querySelector('.st-slide-status').textContent = `Featured toys ${active + 1} of ${slides.length}`;
      };
      carousel.querySelector('[data-st-prev]').addEventListener('click', () => show(active - 1));
      carousel.querySelector('[data-st-next]').addEventListener('click', () => show(active + 1));
      dots.forEach((dot, i) => dot.addEventListener('click', () => show(i)));
      carousel.addEventListener('keydown', event => {
        if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault(); show(active + (event.key === 'ArrowRight' ? 1 : -1));
      });
      let startX, startY;
      carousel.addEventListener('touchstart', event => { startX = event.changedTouches[0].clientX; startY = event.changedTouches[0].clientY; }, { passive: true });
      carousel.addEventListener('touchend', event => {
        const dx = event.changedTouches[0].clientX - startX;
        const dy = event.changedTouches[0].clientY - startY;
        if (Math.abs(dx) > 55 && Math.abs(dx) > Math.abs(dy)) show(active + (dx < 0 ? 1 : -1));
      }, { passive: true });
    });
    root.querySelectorAll('[data-st-rail]').forEach(rail => {
      if (rail.dataset.ready) return;
      rail.dataset.ready = 'true';
      const section = rail.closest('section');
      const previous = section.querySelector('[data-st-rail-prev]');
      const next = section.querySelector('[data-st-rail-next]');
      const update = () => {
        previous.disabled = rail.scrollLeft < 3;
        next.disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 3;
      };
      const move = direction => rail.scrollBy({ left: direction * (rail.firstElementChild.getBoundingClientRect().width + parseFloat(getComputedStyle(rail).gap)), behavior: reduceMotion.matches ? 'instant' : 'smooth' });
      previous.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
      rail.addEventListener('scroll', update, { passive: true });
      if ('ResizeObserver' in window) new ResizeObserver(update).observe(rail);
      update();
    });
    const reveals = root.querySelectorAll('.st-reveal');
    if (!reduceMotion.matches && 'IntersectionObserver' in window) {
      document.documentElement.classList.add('st-motion');
      const observer = new IntersectionObserver(entries => entries.forEach(entry => {
        if (entry.isIntersecting) { entry.target.classList.remove('is-pending'); observer.unobserve(entry.target); }
      }), { threshold: 0.08 });
      reveals.forEach(element => {
        if (element.getBoundingClientRect().top > innerHeight) { element.classList.add('is-pending'); observer.observe(element); }
      });
    }
    root.querySelectorAll('.st-mobile-menu').forEach(menu => {
      if (menu.dataset.ready) return;
      menu.dataset.ready = 'true';
      menu.querySelectorAll('a').forEach(a => a.addEventListener('click', () => { menu.open = false; }));
      menu.addEventListener('keydown', event => {
        if (event.key === 'Escape') { menu.open = false; menu.querySelector('summary').focus(); }
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
  else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
